module.exports = require("./crossfilter").crossfilter;



/*****************
 ** WEBPACK FOOTER
 ** ./~/crossfilter/index.js
 ** module id = 359
 ** module chunks = 1
 **/